module.exports = __webpack_public_path__ + "img/icons-16-line-add-active.fac7cb8e.svg";